module.exports = __webpack_public_path__ + "static/img/sewy.0c51426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/sewy.png
// module id = XtLw
// module chunks = 128